module.exports = __webpack_public_path__ + "assets/img/info-btn-04ccab70.png";